import { extendTheme } from "@chakra-ui/react";
import { commonStyles } from "./common";

export const colors = {
  brand: {
    primary: "#F3BA2F",
    primaryLight: "#FFFAEE",
    primaryText: "#F3BA2F",
    background: "#202022",
    backgroundLight: "#2B2B2B",
    textBg: "#1D1D1D",
    textColor: "#ffffff",
    textLight: "#ffffff",
    textInactive: "#8F8F8F",
    separator: "#424242",
    errorColor: "#FF002E",
    toolTipBg: "#EEEEEF",
    toolTipText: "#060710",
  },
};

export const styles = {
  global: () => ({
    body: {
      bg: "brand.background",
      fontFamily: "regular",
      color: "brand.textColor",
    },
  }),
};

const theme = extendTheme({
  colors,
  styles,
  ...commonStyles,
});

export default theme;
